"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSTANT_COMPARISONS_FLAG = exports.COLOR_INDICATORS_FLAG = void 0;
exports.COLOR_INDICATORS_FLAG = 'metricsColorIndicatorsEnabled';
exports.CONSTANT_COMPARISONS_FLAG = 'metricsReferenceLineEnabled';
//# sourceMappingURL=FeatureFlags.js.map